export default {
  data() {
    return {
    };
  },
  props: ['title', 'client', 'start', 'end'],
  template: '<div class="appointment shadow clickable">' +
    '<span class="icon"><i class="fal fa-calendar"></i></span>' +
    '<span class="date">{{ $t("appointment-date", { start: $moment(start).format("HH:mm"), end: $moment(end).format("HH:mm"), date: $moment(start).format("DD-MM") }) }}</span>' +
    '<span class="title">{{title | truncate(50) }}</span><br/>' +
    '<span class="client">{{client | truncate(50) }}</span>' +
    '</div>',
};



// WEBPACK FOOTER //
// ./src/components/Appointment.js